import { state } from './state.js';
import { addMarkerCategoryFilter, removeMarkerCategoryFilter, toggleAllMarkersOn, showOnlyMarkers, searchMarkers } from './markers.js';

const RESULTS_PER_PAGE = 8;
import { updateSideBar, updateSidebarHearts } from './sidebar.js';
import { loadOnlineBuisnessesModalResults, composeOnlineOnlyModal, outputModalData } from './modals.js';
import { removeAllChildNodes, escapeHtml as escapeAttr } from './helpers.js';
import { announceMapStatus, generateCard, generateSkeletonCard, generateFilterPill, cleanupUnusedPills, setSidebarExpanded, syncFilterToggleState } from './ui.js';
import { placeFetchData, placeFetchDescription, sendEmail } from './api.js';
import _ from 'lodash';

/**
 * Handle input switch (checkboxes)
 */
export function inputSwitchHandler(target = null) {
	if (target === null) {
		return;
	}
	let checked = target.checked;
	let descendants = target.closest('.category-input-wrapper').querySelector('.sub-cat');
	let checkboxes = descendants.getElementsByTagName('input');

	for (let i = 0; i < checkboxes.length; i++) {
		if (!checked) {
			checkboxes[i].checked = false;
			let event = new Event('change');
			checkboxes[i].dispatchEvent(event);
		} else {
			checkboxes[i].checked = true;
			let event = new Event('change');
			checkboxes[i].dispatchEvent(event);
		}
	}
	$(descendants).slideToggle();
	updateFiltersFromCheckboxes();
}

/**
 * Update filters based on current checkbox states
 */
export function updateFiltersFromCheckboxes() {
	function checkOnlineOnly(arr, val) {
		return arr.some(function(arrVal) {
			return arrVal.location_category.includes(parseInt(...val));
		});
	}
	
	let allButtons = document.querySelectorAll('#highlights .highlight-button.active');
	_.forEach(allButtons, function (value) {
		value.classList.remove('active');
	});
	
	const checkedValues = Array
		.from(document.querySelectorAll('#filters input[type="checkbox"]'))
		.filter((checkbox) => checkbox.checked)
		.map((checkbox) => checkbox.value);
	
	if (checkOnlineOnly(state.onlineOnlyBusinesses.businesses, checkedValues)) {
		document.getElementById('online-business').classList.remove('hide');
	} else {
		document.getElementById('online-business').classList.add('hide');
	}
	
	let elem = document.querySelector('#view-all');

	if (checkedValues.length > 0) {
		elem.style.display = 'none';
		addMarkerCategoryFilter(checkedValues);
		if (state.vw >= 640) {
			document.querySelector('#sidebar-wrapper').classList.remove('off-screen');
			setSidebarExpanded(true);
			updateSideBar(true);
		}
	} else {
		elem.style.display = 'block';
		toggleAllMarkersOn();
		document.querySelector('#sidebar-wrapper').classList.add('off-screen');
		setSidebarExpanded(false);
	}
}

/**
 * Setup all event listeners
 */
export function setupEventListeners() {
	setSidebarExpanded(!document.querySelector('#sidebar-wrapper')?.classList.contains('off-screen'));
	syncFilterToggleState();

	// Window resize
	window.onresize = () => {
		state.vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
	};

	// Global Click Listener
	document.addEventListener('click', function (event) {
		// Sidebar Toggler
		if (event.target.closest('#sidebar-toggler')) {
			$('#sidebar-wrapper').toggleClass("off-screen");
			const expanded = !document.querySelector('#sidebar-wrapper').classList.contains('off-screen');
			setSidebarExpanded(expanded);
			announceMapStatus(expanded ? 'Business results list opened.' : 'Business results list closed.');
		}
		
		// Online Business Toggler
		if (event.target.closest('#online-business button')) {
			const sideBar = document.querySelector('#sidebar-wrapper');
			if (sideBar) {
				sideBar.classList.remove('off-screen');
				setSidebarExpanded(true);
				// Force a sidebar update that includes virtual businesses
				updateSideBar(true);
				
				// Smooth scroll to the top of the sidebar
				const scrollContainer = document.getElementById('map-sidebar');
				if (scrollContainer) {
					scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
				}
			}
		}
		
		// Search Results - View Profile (Direct)
		if (event.target.closest('.search-result-view-profile')) {
			const btn = event.target.closest('.search-result-view-profile');
			state.lastFocusedElement = btn;
			const id = btn.dataset.id;
			const isOnline = id.toString().startsWith('ob_');
			
			// Close search modal
			$('#search-modal').foundation('close');
			
			if (isOnline) {
				// Resolve and show online modal
				const realId = parseInt(id.replace('ob_', ''));
				const business = state.onlineOnlyBusinesses.businesses.find(b => b.id === realId);
				if (business) {
					composeOnlineOnlyModal(business.id);
				}
			} else {
				// Plot ALL results so the user isn't stuck with one
				showOnlyMarkers(state.search.markers);
				
				// Make the search results pill visible so they can clear it later
				const pill = document.getElementById('search-pill');
				if (pill) pill.style.setProperty('display', 'block', 'important');
				
				// Open the profile modal
				const marker = state.markers.find(m => m.properties.post_id == id);
				if (marker) {
					const lat = parseFloat(btn.dataset.lat);
					const lng = parseFloat(btn.dataset.lng);
					const placeId = btn.dataset.placeId;
					outputModalData(marker, lat, lng, placeId);
				}
			}
		}
		
		// Online Profile View
		if (event.target.closest('.online-profile-view')) {
			const button = event.target.closest('.online-profile-view');
			state.lastFocusedElement = button;
			const id = button.dataset.id;
			composeOnlineOnlyModal(id);
		}
		
		// Info Window From Sidebar
		if (event.target.closest('.info-window-trigger-button')) {
			event.preventDefault();
			state.lastFocusedElement = event.target.closest('.info-window-trigger-button');
			handleSidebarInfoWindowClick(event);
		}

		// Header Interests Button
		if (event.target.closest('.button.interest')) {
			// Try to open via Elementor Frontend API first for cleanest result
			if (window.elementorFrontend && window.elementorFrontend.modules.popup) {
				// Elementor popup ID for the interests bar is 1319
				window.elementorFrontend.modules.popup.showPopup({ id: 1319 });
			} else {
				// Fallback to finding the trigger and clicking it, or showing manual
				const interestBar = document.getElementById('interestbar');
				if (interestBar) {
					interestBar.style.display = 'flex';
					const offCanvas = interestBar.closest('.e-off-canvas');
					if (offCanvas) offCanvas.setAttribute('aria-hidden', 'false');
				}
			}

			// Always trigger a UI refresh when opening
			if (window.bccInterestsManager) {
				window.bccInterestsManager.updateAllForms();
			}
		}
		// Search Modal Open
		if (event.target.closest('#cat-search .button')) {
			state.lastFocusedElement = event.target.closest('#cat-search .button');
			handleSearchButtonClick(event);
		}
		
		// Plot Search Results
		if (event.target.closest('#plotSearchResults')) {
			handlePlotSearchResults();
		}

		// Search Pagination
		if (event.target.closest('#search-prev-page')) {
			if (state.search.currentPage > 1) renderSearchPage(state.search.currentPage - 1);
		}
		if (event.target.closest('#search-next-page')) {
			const totalPages = Math.ceil(state.search.allResults.length / RESULTS_PER_PAGE);
			if (state.search.currentPage < totalPages) renderSearchPage(state.search.currentPage + 1);
		}
		
		// Category Filter Toggle
		if (event.target.closest('.cat-filter, .close-cat')) {
			$("#cat-contain").slideToggle("fast", syncFilterToggleState);
		}
		
		// Highlights / Whats Hot
		if (event.target.closest('#highlights .highlight-button')) {
			handleHighlightButtonClick(event);
		}
		
		// Filters Switch
		if (event.target.closest('#filters .switch input, #online-only-filter')) {
			let checked = event.target.closest('#filters .switch input, #online-only-filter');
			if (checked.id === 'online-only-filter') {
				handleOnlineOnlyFilterChange(checked);
			} else if (checked.id === 'global-expand-filters') {
				handleGlobalExpandToggle(checked);
			} else {
				inputSwitchHandler(checked);
			}
		}
		// Interest Bar Close
		if (event.target.closest('#interestbar .elementor-element-7017829') || event.target.closest('#interestbar .elementor-icon')) {
			const offCanvas = event.target.closest('.e-off-canvas');
			if (offCanvas) {
				const overlay = offCanvas.querySelector('.e-off-canvas__overlay');
				if (overlay) {
					overlay.click();
					return;
				}
			}
			const interestBar = document.getElementById('interestbar');
			if (interestBar) {
				interestBar.style.display = 'none';
			}
		}
		
		// Search Pill Remove
		if (event.target.closest('#search-pill .search-result-remove-button')) {
			document.getElementById('search-pill').style.setProperty('display', 'none', 'important');
			toggleAllMarkersOn();
			state.search.markers = [];
			state.search.isActive = false;
			if (!state.search.sidebarWasOpen) {
				document.querySelector('#sidebar-wrapper').classList.add('off-screen');
				setSidebarExpanded(false);
			}
			state.search.sidebarWasOpen = false;
			announceMapStatus('Search results cleared. Showing all businesses.');
		}
		
		// Sub-category checkboxes
		if (event.target.closest('#filters .sub-cat li')) {
			handleSubCatCheckboxClick(event);
		}
		
		// Cat Pill Remove
		if (event.target.closest('.cat-pill')) {
			handleCatPillRemove(event);
		}
		
		// Interests Remove
		if (event.target.closest('.interest-remove')) {
			event.preventDefault();
			handleInterestRemove(event);
		}

		// Clear All Interests
		if (event.target.closest('#clearInterests')) {
			event.preventDefault();
			handleClearInterests();
		}

		// Add to Interests from Modal
		if (event.target.closest('.location-modal-interests')) {
			event.preventDefault();
			handleAddToInterests(event);
		}

		// Add to Interests from Search Results cards
		if (event.target.closest('.interest-add-button')) {
			event.preventDefault();
			handleSearchCardAddToInterests(event);
		}

		// Add to Interests from Sidebar heart button
		if (event.target.closest('.sidebar-add-interest')) {
			event.preventDefault();
			handleSidebarAddToInterests(event);
		}
	}, false);

	// Space-key activation for role="button" highlight links (anchors don't get this natively)
	document.addEventListener('keydown', function (event) {
		if (event.key === ' ' || event.key === 'Spacebar') {
			const highlightButton = event.target.closest('#highlights .highlight-button');
			if (highlightButton) {
				event.preventDefault();
				highlightButton.click();
			}
		}
	}, false);

	// Load existing interests from local storage - CALL AFTER FUNCTIONS ARE DEFINED
	loadInterests();

	// Search Input
	document.getElementById('cat-search-input').addEventListener('input', function () {
		document.getElementById('search-validation-msg').style.display = 'none';
		this.classList.remove('is-invalid-input');
		if (this.value.length >= 3) {
			document.querySelector('#cat-search .submit').removeAttribute("disabled");
			document.querySelector('#cat-search .submit').setAttribute('aria-disabled', 'false');
		} else {
			document.querySelector('#cat-search .submit').setAttribute("disabled", 'disabled');
			document.querySelector('#cat-search .submit').setAttribute('aria-disabled', 'true');
		}
	}, false);

	// Search Input Enter Key
	document.getElementById('cat-search-input').addEventListener('keydown', function (event) {
		if (event.key === 'Enter') {
			event.preventDefault();
			if (this.value.length >= 3) {
				handleSearchButtonClick(event);
			} else {
				document.getElementById('search-validation-msg').style.display = 'block';
				this.classList.remove('is-invalid-input');
				void this.offsetWidth;
				this.classList.add('is-invalid-input');
			}
		}
	});

	// Modal State Listeners
	$(document).on('open.zf.reveal', '#location, #onlineLocation', function () {
		state.isModalOpen = true;
	});

	$(document).on('closed.zf.reveal', '#location, #onlineLocation', function () {
		state.isModalOpen = false;
		if (state.lastFocusedElement && typeof state.lastFocusedElement.focus === 'function' && document.contains(state.lastFocusedElement)) {
			state.lastFocusedElement.focus();
		}
		// Refresh sidebar now that modal is closed
		updateSideBar();
	});

	$(document).on('closed.zf.reveal', '#search-modal', function () {
		if (state.lastFocusedElement && typeof state.lastFocusedElement.focus === 'function' && document.contains(state.lastFocusedElement)) {
			state.lastFocusedElement.focus();
		}
	});
}

// --- Specific Handler Functions ---

function handleSidebarInfoWindowClick(event) {
	let button = event.target.closest('.info-window-trigger-button');
	let placeId = button.dataset.placeId;
	let postId = button.dataset.postId;
	
	let marker = state.markers.find(m => {
		if (postId && m.properties.post_id == postId) return true;
		if (placeId && placeId !== 'null' && placeId !== '' && m.properties.place_id == placeId) return true;
		return false;
	});

	if (!marker) {
		console.warn('Marker not found for sidebar click', { placeId, postId });
		return;
	}

	let pos = marker.position;
	if (!pos) return;

	let lat = typeof pos.lat === 'function' ? pos.lat() : pos.lat;
	let lng = typeof pos.lng === 'function' ? pos.lng() : pos.lng;

	if (lat === undefined || lng === undefined) {
		// Fallback for some AdvancedMarker types
		lat = pos.lat;
		lng = pos.lng;
	}

	let zoom = state.map.getZoom();
	let sideBar = document.querySelector("#sidebar-wrapper");
	
	const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	// Performance fix: Don't do 3D pan and zoom animation on mobile (vw < 768)
	if (state.vw < 768 || reduceMotion) {
		console.log('Mobile device detected, jumping to location for performance');
		state.map.setCenter({ lat: lat, lng: lng });
		state.map.setZoom(18);
		// Force standard 2D view for mobile performance
		state.map.setTilt(0);
		state.map.setHeading(0);
		
		outputModalData(marker);
		if (sideBar) sideBar.classList.add('off-screen');
		return;
	}

	try {
		// Stop any existing tween
		if (state.activeTween) {
			state.activeTween.stop();
		}

		state.isAnimating = true;
		const cameraOptions = {
			tilt: state.map.getTilt(),
			heading: state.map.getHeading(),
			zoom: zoom,
			center: { lat: state.map.getCenter().lat(), lng: state.map.getCenter().lng() }
		};

		state.activeTween = new state.Tween(cameraOptions)
			.to({ tilt: 65, heading: 20, zoom: 18, center: { lat: lat, lng: lng } }, 1200)
			.easing(state.Easing.Quadratic.Out)
			.onUpdate(() => {
				state.map.moveCamera(cameraOptions);
			})
			.onComplete(() => {
				outputModalData(marker);
				state.isAnimating = false;
				state.activeTween = null;
				// Trigger one final update now that animation is done
				updateSideBar();
			})
			.start();

		const animate = (time) => {
			if (state.isAnimating) {
				requestAnimationFrame(animate);
				state.TWEEN.update(time);
			}
		};
		requestAnimationFrame(animate);
	} catch (e) {
		console.error('Animation failed', e);
		state.isAnimating = false;
		state.activeTween = null;
		outputModalData(marker);
	}
}

function handleSearchButtonClick(event) {
	const searchInput = document.getElementById('cat-search-input');
	const validationMsg = document.getElementById('search-validation-msg');

	if (searchInput.value.length < 3) {
		validationMsg.style.display = 'block';
		searchInput.classList.remove('is-invalid-input');
		void searchInput.offsetWidth;
		searchInput.classList.add('is-invalid-input');
		return;
	}

	validationMsg.style.display = 'none';
	searchInput.classList.remove('is-invalid-input');

	const searchValue = searchInput.value;
	const results = searchMarkers(searchValue);
	const modalBody = document.querySelector('#search-modal #results-modal-body');

	removeAllChildNodes(modalBody);
	document.getElementById('plotSearchResults').style.display = 'none';
	document.getElementById('search-modal').querySelector('h2 strong').textContent = searchValue;
	document.getElementById('search-pagination').style.display = 'none';

	for (let i = 0; i < 6; i++) {
		modalBody.appendChild(generateSkeletonCard());
	}
	$('#search-modal').foundation('open');

	if (results.length > 0) {
		announceMapStatus(`${results.length} search ${results.length === 1 ? 'result' : 'results'} found for ${searchValue}.`);
		state.search.markers = results;
		state.search.allResults = results;
		state.search.currentPage = 1;
		setTimeout(() => {
			removeAllChildNodes(modalBody);
			document.getElementById('plotSearchResults').style.display = 'inline-block';
			renderSearchPage(1);
		}, 300);
	} else {
		announceMapStatus(`No search results found for ${searchValue}.`);
		state.search.markers = [];
		state.search.allResults = [];
		modalBody.innerHTML = "<div class='search-none'><p><i class='far fa-meh-blank'></i> No Results Found</p></div>";
	}
}

function renderSearchPage(page) {
	const all = state.search.allResults;
	const totalPages = Math.ceil(all.length / RESULTS_PER_PAGE);
	const modalBody = document.querySelector('#search-modal #results-modal-body');
	const pagination = document.getElementById('search-pagination');

	state.search.currentPage = page;

	const start = (page - 1) * RESULTS_PER_PAGE;
	const pageResults = all.slice(start, start + RESULTS_PER_PAGE);

	removeAllChildNodes(modalBody);

	const searchObserver = setupSearchImageObserver();
	drawCardsAsync(pageResults, null, searchObserver);

	// Scroll modal to top
	const modal = document.getElementById('search-modal');
	if (modal) modal.scrollTop = 0;

	// Update pagination controls
	if (totalPages > 1) {
		pagination.style.display = 'flex';
		document.getElementById('search-page-info').textContent = `Page ${page} of ${totalPages}`;
		document.getElementById('search-prev-page').disabled = page <= 1;
		document.getElementById('search-prev-page').setAttribute('aria-disabled', page <= 1 ? 'true' : 'false');
		document.getElementById('search-next-page').disabled = page >= totalPages;
		document.getElementById('search-next-page').setAttribute('aria-disabled', page >= totalPages ? 'true' : 'false');
	} else {
		pagination.style.display = 'none';
	}
}

function handlePlotSearchResults() {
	const sideBar = document.querySelector('#sidebar-wrapper');
	state.search.sidebarWasOpen = !sideBar.classList.contains('off-screen');
	$('#search-modal').foundation('close');
	state.search.isActive = true;
	let pill = document.getElementById('search-pill');
	const searchInput = document.getElementById('cat-search-input');
	if (searchInput) {
		pill.querySelector('span').textContent = searchInput.value;
	}
	pill.style.setProperty('display', 'block', 'important');
	if (!state.search.sidebarWasOpen) {
		sideBar.classList.remove('off-screen');
		setSidebarExpanded(true);
	}
	showOnlyMarkers(state.search.markers);
	updateSideBar(true);
}

function handleHighlightButtonClick(event) {
	let target = event.target.closest('#highlights .highlight-button');
	if (target.classList.contains('active')) {
		target.classList.toggle("active");
		target.setAttribute('aria-pressed', 'false');
		document.querySelector('#sidebar-wrapper').classList.add('off-screen');
		setSidebarExpanded(false);
		toggleAllMarkersOn();
		return;
	}

	document.querySelectorAll('#highlights .highlight-button.active').forEach(btn => {
		btn.classList.remove('active');
		btn.setAttribute('aria-pressed', 'false');
	});

	// Clear any active category filters before applying highlight
	state.filterCategories.length = 0;
	document.querySelectorAll('#filters input[type="checkbox"]').forEach(cb => cb.checked = false);
	cleanupUnusedPills();
	document.getElementById('online-business').classList.add('hide');

	const markerIds = JSON.parse(target.dataset.markerIds);
	const filtered = state.markers.filter(marker => markerIds.includes(marker.properties.post_id));

	let reformattedArray = filtered.map(marker => ({ item: marker }));

	showOnlyMarkers(reformattedArray);
	updateSideBar(true);
	target.classList.toggle("active");
	target.setAttribute('aria-pressed', 'true');
	document.querySelector('#sidebar-wrapper').classList.remove('off-screen');
	setSidebarExpanded(true);
}

function handleOnlineOnlyFilterChange(target) {
	const pillBar = document.getElementById('pill-bar');
	const isChecked = target.checked;
	
	if (isChecked) {
		const pill = generateFilterPill('ONLINE ONLY', 'online-only', '#007e00');
		pill.id = 'online-only-pill';
		// Add close listener to the pill's 'x' link
		const closeLink = pill.querySelector('button');
		closeLink.addEventListener('click', (e) => {
			e.preventDefault();
			target.checked = false;
			pill.remove();
			updateSideBar(true);
			announceMapStatus('Online only filter removed.');
		});
		pillBar.appendChild(pill);
	} else {
		const existing = document.getElementById('online-only-pill');
		if (existing) existing.remove();
	}
	
	updateSideBar(true);
	
	// Open sidebar if closed
	const sideBar = document.querySelector('#sidebar-wrapper');
	if (sideBar && isChecked) {
		sideBar.classList.remove('off-screen');
		setSidebarExpanded(true);
	}
}

function handleGlobalExpandToggle(target) {
	const isChecked = target.checked;
	const subCats = document.querySelectorAll('#filters .sub-cat');
	
	subCats.forEach(el => {
		if (isChecked) {
			$(el).slideDown();
		} else {
			$(el).slideUp();
		}
	});
}

function handleSubCatCheckboxClick(event) {
	let checkedBox = event.target.closest('#filters .sub-cat li').querySelector('input[type="checkbox"]');
	if (!checkedBox.checked) {
		const checkedValues = Array.from(event.target.closest('#filters .sub-cat ul').querySelectorAll('input[type="checkbox"]'))
			.filter(cb => cb.checked);
		
		if (checkedValues.length < 1) {
			let parent = event.target.closest('.category-input-wrapper').querySelector('.cat-header input[type="checkbox"]');
			let subCat = checkedBox.closest('#filters .sub-cat');
			if (!parent.checked) {
				$(subCat).slideToggle();
			}
		}
	}
	updateFiltersFromCheckboxes();
}

function handleCatPillRemove(event) {
	let target = event.target.closest('.cat-pill');
	let link = target.querySelector('button');
	target.parentNode.removeChild(target);

	const termId = link.dataset.termId;
	const checkbox = document.querySelector(`#filters input[type="checkbox"][value="${termId}"], #filters input[type="checkbox"][data-term-id="${termId}"]`);
	if (checkbox) {
		checkbox.checked = false;
	}

	updateFiltersFromCheckboxes();
}

function handleInterestRemove(event) {
	let target = event.target.closest('.interest-wrapper');
	let title = target?.querySelector('.interest-contain')?.textContent || 'Item';
	
	if (target) {
		const id = target.querySelector('[data-post-id]')?.dataset.postId;
		// Remove from all containers if we have multiples
		if (id) {
			const allMatches = document.querySelectorAll(`#interests-card-wrapper [data-post-id="${id}"]`);
			allMatches.forEach(el => el.closest('.interest-wrapper')?.remove());
		} else {
			target.remove();
		}
	}
	updateInterestCount();
	saveInterests();
	updateSidebarHearts();

	// Removal Toast
	Swal.fire({
		toast: true,
		position: 'top-end',
		icon: 'info',
		title: `Removed: ${title}`,
		showConfirmButton: false,
		timer: 2500,
		timerProgressBar: true
	});
	
	document.dispatchEvent(new CustomEvent('bcc_interests_updated', { 
		detail: { action: 'remove' } 
	}));
}

function handleClearInterests() {
	Swal.fire({
		title: 'Clear All Interests?',
		text: "This will remove all items from your itinerary list.",
		icon: 'warning',
		showCancelButton: true,
		confirmButtonColor: '#007e00',
		cancelButtonColor: '#d33',
		confirmButtonText: 'Yes, clear it!'
	}).then((result) => {
		if (result.isConfirmed) {
			const containers = document.querySelectorAll('#interests-card-wrapper');
			containers.forEach(container => {
				removeAllChildNodes(container);
			});
			updateInterestCount();
			saveInterests();
			updateSidebarHearts();

			const interestBar = document.getElementById('interestbar');
			if (interestBar) {
				interestBar.style.display = 'none';
			}

			document.dispatchEvent(new CustomEvent('bcc_interests_updated', { 
				detail: { action: 'clear' } 
			}));
		}
	});
}

function handleAddToInterests(event) {
	let button = event.target.closest('.location-modal-interests');
	let id = button.dataset.postId;
	let title = button.dataset.title;
	
	if (!id || !title) return;

	// Prevent duplicates
	let existing = document.querySelector(`#interests-card-wrapper [data-post-id="${id}"]`);
	if (existing) {
		Swal.fire({
			toast: true,
			position: 'top-end',
			icon: 'info',
			title: 'Already in your list',
			showConfirmButton: false,
			timer: 2000,
			timerProgressBar: true
		});
		$(button).closest('[data-reveal]').foundation('close');
		return;
	}
	
	addInterestToDOM(id, title);
	updateInterestCount();
	saveInterests();
	updateSidebarHearts();

	// Close modal and show confirmation toast
	$(button).closest('[data-reveal]').foundation('close');

	// Toast notification
	Swal.fire({
		toast: true,
		position: 'top-end',
		icon: 'success',
		title: 'Added to your list!',
		showConfirmButton: false,
		timer: 3000,
		timerProgressBar: true
	});

	document.dispatchEvent(new CustomEvent('bcc_interests_updated', { 
		detail: { id, title, action: 'add' } 
	}));
}

function handleSearchCardAddToInterests(event) {
	const button = event.target.closest('.interest-add-button');
	const id = button.dataset.postId || button.dataset.id;
	const title = button.dataset.title;

	if (!id || !title) return;

	const existing = document.querySelector(`#interests-card-wrapper [data-post-id="${id}"]`);
	if (existing) {
		Swal.fire({
			toast: true,
			position: 'top-end',
			icon: 'info',
			title: 'Already in your list',
			showConfirmButton: false,
			timer: 2000,
			timerProgressBar: true
		});
		return;
	}

	addInterestToDOM(id, title);
	updateInterestCount();
	saveInterests();
	updateSidebarHearts();

	button.innerHTML = '<i class="fas fa-heart"></i> ADDED';
	button.style.pointerEvents = 'none';
	button.style.opacity = '0.7';

	Swal.fire({
		toast: true,
		position: 'top-end',
		icon: 'success',
		title: 'Added to your list!',
		showConfirmButton: false,
		timer: 3000,
		timerProgressBar: true
	});

	document.dispatchEvent(new CustomEvent('bcc_interests_updated', {
		detail: { id, title, action: 'add' }
	}));
}

function handleSidebarAddToInterests(event) {
	const button = event.target.closest('.sidebar-add-interest');
	if (!button) return;

	// Debounce — prevent accidental double-tap toggling
	const now = Date.now();
	if (button._lastClick && now - button._lastClick < 500) return;
	button._lastClick = now;

	const id = button.dataset.postId;
	const title = button.dataset.title;
	if (!id || !title) return;

	const existing = document.querySelector(`#interests-card-wrapper [data-post-id="${id}"]`);

	if (existing) {
		// Already in list — remove it
		document.querySelectorAll(`#interests-card-wrapper [data-post-id="${id}"]`)
			.forEach(el => el.closest('.interest-wrapper')?.remove());
		updateInterestCount();
		saveInterests();
		updateSidebarHearts();

		Swal.fire({
			toast: true,
			position: 'top-end',
			icon: 'info',
			title: `Removed: ${title}`,
			showConfirmButton: false,
			timer: 2000,
			timerProgressBar: true
		});

		document.dispatchEvent(new CustomEvent('bcc_interests_updated', {
			detail: { action: 'remove' }
		}));
		return;
	}

	// Not in list — add it
	addInterestToDOM(id, title);
	updateInterestCount();
	saveInterests();
	updateSidebarHearts();

	Swal.fire({
		toast: true,
		position: 'top-end',
		icon: 'success',
		title: 'Added to your list!',
		showConfirmButton: false,
		timer: 3000,
		timerProgressBar: true
	});

	document.dispatchEvent(new CustomEvent('bcc_interests_updated', {
		detail: { id, title, action: 'add' }
	}));
}

// Helpers for event handlers

function addInterestToDOM(id, title) {
	const containers = document.querySelectorAll('#interests-card-wrapper');

	containers.forEach((container, index) => {
		let div = document.createElement('div');
		div.classList.add('interest-wrapper');
		let html = `<div data-post-id="${escapeAttr(id)}" class="cell padb1">
			<span class="interest-contain">${escapeAttr(title)}</span>
			<button type="button" class="interest-remove" aria-label="Remove ${escapeAttr(title)} from interests"><i class="fa fa-times" aria-hidden="true"></i></button>
		</div>`;
		div.innerHTML = html;
		container.appendChild(div);
	});

	// Show the Elementor interest bar
	const interestBar = document.getElementById('interestbar');
	if (interestBar) {
		interestBar.style.display = 'flex';
	}
}

function updateInterestCount() {
	const items = document.querySelectorAll('#interests-card-wrapper .interest-wrapper');
	const count = new Set();
	items.forEach(item => {
		const id = item.querySelector('[data-post-id]')?.dataset.postId;
		if (id) count.add(id);
	});

	state.interestCount.count = count.size;
	
	// 1. Target standard theme button counter
	let countBubble = document.getElementById('interestCount');
	if (countBubble) {
		countBubble.innerHTML = state.interestCount.count;
		countBubble.style.display = state.interestCount.count <= 0 ? 'none' : 'inline-block';
	}

	// 2. Target Sarah's Elementor header button
	// We look for any elementor button text that says "My Interests" to be flexible
	const elementorButtons = document.querySelectorAll('.elementor-button-text');
	elementorButtons.forEach(btn => {
		if (btn.textContent.trim().toLowerCase().includes('my interests')) {
			let elBadge = btn.querySelector('.interest-count-badge');
			if (!elBadge) {
				elBadge = document.createElement('span');
				elBadge.className = 'interest-count-badge';
				btn.appendChild(elBadge);
			}
			elBadge.innerHTML = state.interestCount.count;
			elBadge.style.display = state.interestCount.count <= 0 ? 'none' : 'inline-block';
		}
	});
}

function saveInterests() {
	const items = document.querySelectorAll('#interests-card-wrapper [data-post-id]');
	const interests = [];
	const seenIds = new Set();
	
	items.forEach(item => {
		const id = item.getAttribute('data-post-id');
		const title = item.querySelector('.interest-contain')?.textContent || 'Location';
		if (id && !seenIds.has(id)) {
			seenIds.add(id);
			interests.push({ id, title });
		}
	});
	
	localStorage.setItem('bcc_interests', JSON.stringify(interests));
}

function loadInterests() {
	const saved = localStorage.getItem('bcc_interests');
	if (saved) {
		try {
			const interests = JSON.parse(saved);
			if (Array.isArray(interests)) {
				interests.forEach(item => {
					addInterestToDOM(item.id, item.title);
				});
				updateInterestCount();
			}
		} catch (e) {
			console.error('Failed to parse saved interests', e);
		}
	}
}

function setupSearchImageObserver() {
	const scrollRoot = document.querySelector('#search-modal #results-modal-body');
	return new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				const cardNode = entry.target;
				const image = cardNode.querySelector('.location-pic');
				const placeID = cardNode.dataset.markerId;
				const originalBg = image.dataset.background;

				// If it's a marker and needs photo lookup
				if (originalBg.includes('placeholder.png') && !cardNode.dataset.onlineOnly) {
					const marker = state.markerMap.get(parseInt(placeID)) || state.markerMap.get(placeID);
					if (marker) {
						if (marker.places_results?.photos) {
							const imageRef = marker.places_results.photos[0].photo_reference;
							const newUrl = `/wp-content/plugins/geojson-generator/get-place-images.php?photo_ref=${imageRef}`;
							image.style.background = `url(${newUrl})`;
							image.classList.remove('blur');
						} else {
							const gmpPlaceId = marker.properties.place_id;
							if (gmpPlaceId) {
								placeFetchData(gmpPlaceId, 'photo').then(response => {
									if (response?.result?.photos) {
										marker.places_results = marker.places_results || {};
										marker.places_results.photos = response.result.photos;
										const imageRef = response.result.photos[0].photo_reference;
										const newUrl = `/wp-content/plugins/geojson-generator/get-place-images.php?photo_ref=${imageRef}`;
										image.style.background = `url(${newUrl})`;
									} else {
										// Fallback to placeholder if no photos
										image.style.background = `url(${originalBg})`;
									}
									image.classList.remove('blur');
								}).catch(e => {
									console.error(e);
									image.style.background = `url(${originalBg})`;
									image.classList.remove('blur');
								});
							} else {
								image.style.background = `url(${originalBg})`;
								image.classList.remove('blur');
							}
						}
					} else {
						image.style.background = `url(${originalBg})`;
						image.classList.remove('blur');
					}
				} else {
					// Direct background set for online businesses or already known photos
					image.style.background = `url(${originalBg})`;
					image.classList.remove('blur');
				}
				
				placeFetchDescription(placeID).then((response) => {
					let description = cardNode.querySelector('.seach-card-descripton');
					if (response && response[0]?.acf?.location_description) {
						description.innerHTML = String(response[0].acf.location_description).substring(0, 200) + '...';
					} else {
						let target = state.onlineOnlyBusinesses.businesses.find(b => b.id === parseInt(placeID));
						description.innerHTML = target?.description || "No description available.";
					}
				}).catch(e => {
					console.log(e);
					let description = cardNode.querySelector('.seach-card-descripton');
					if (description) description.innerHTML = "No description available.";
				}).finally(() => {
					let description = cardNode.querySelector('.seach-card-descripton');
					if (description) description.classList.remove('blur');
				});
				
				observer.unobserve(cardNode);
			}
		});
	}, { root: scrollRoot, threshold: 0.1 });
}

async function drawCardsAsync(results, searchValue, searchObserver) {
	const modalBody = document.querySelector('#search-modal #results-modal-body');

	// Yield for UI responsiveness
	await new Promise(resolve => setTimeout(resolve, 0));

	for (const result of results) {
		let image = "/wp-content/themes/bcc_theme/images/placeholder.png";
		const isOnline = !result.item.properties;
		
		if (!isOnline) {
			if (result.item.places_results?.photos) {
				const imageRef = result.item.places_results.photos[0].photo_reference;
				image = `/wp-content/plugins/geojson-generator/get-place-images.php?photo_ref=${imageRef}`;
			}
		} else {
			image = result.item.image?.[0] || image;
		}

		const card = generateCard(result, image, isOnline);
		card.observer = searchObserver;
		if (isOnline) card.dataset.onlineOnly = "true";
		modalBody.appendChild(card);
		searchObserver.observe(card);
		
		// Chunking for UI responsiveness
		if (results.indexOf(result) % 5 === 0) {
			await new Promise(resolve => setTimeout(resolve, 0));
		}
	}

	if (searchValue) {
		document.getElementById('search-modal').querySelector('h2 strong').textContent = searchValue;
		let pill = document.getElementById('search-pill');
		pill.querySelector('span').textContent = searchValue;
	}
}
